import { ButtonType } from '../../types/ButtonType';
import { TimeInputType } from '../types/TimeInputType';
import { TimeInputProps } from '../types/TimeInputProps';
// @ts-ignore
import moment from 'moment';
import DateUtils from '../../dateutils/DateUtils';

export default class TimeInputButtonUtils {
  static isEnabledButton(
    buttonType: ButtonType,
    timeInputType: TimeInputType,
    props: TimeInputProps
  ): boolean {
    const currentMoment = moment(props.value);

    if (timeInputType === 'hour') {
      const currentHour = currentMoment.hour();
      if (buttonType === 'increment') {
        const nextIncrementedHour = currentHour + props.buttonSingleClickStepCountForHour;
        return nextIncrementedHour <= DateUtils.MAX_HOUR;
      } else {
        const nextDecrementedHour = currentHour - props.buttonSingleClickStepCountForHour;
        return nextDecrementedHour >= 0;
      }
    } else {
      const currentMinute = currentMoment.minute();
      if (buttonType === 'increment') {
        const nextIncrementedMinute = currentMinute + props.buttonSingleClickStepCountForMinute;
        return nextIncrementedMinute <= DateUtils.MAX_MINUTE;
      } else {
        const nextDecrementedMinute = currentMinute - props.buttonSingleClickStepCountForMinute;
        return nextDecrementedMinute >= 0;
      }
    }
  }
}
